import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragDropHorizontal = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M7.25 16a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm5.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm-5.5-6.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5Zm5.5 0a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM7.25 2.5a.75.75 0 1 1-.75.75l.004-.077A.75.75 0 0 1 7.25 2.5Zm5.5 0a.75.75 0 1 1-.077.004l.077-.004Z"
	})]
});
const ForwardRef = forwardRef(SvgDragDropHorizontal);
export { ForwardRef as ReactComponent };
